const WECHAT_BROWSER_REGEX = /MicroMessenger/

export const getUA = (ctx?: any) => {
  return ctx?.req?.headers['user-agent'] || navigator.userAgent
}
export const checkIsWechatBrowser = (ua: string = getUA()) => {
  return ua.match(WECHAT_BROWSER_REGEX)
}

export const checkIsPcBrowser = () => {
  const ua = navigator.userAgent
  return !ua.match(/AppleWebKit.*Mobile.*/)
}